// extracted by mini-css-extract-plugin
export default {"add-products":"AddProducts_add-products__RGoOW","add-products--title":"AddProducts_add-products--title__Q-tof"};